"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _B2PY6EORcjs = require('../__chunks/B2PY6EOR.cjs');


var _FHIGX2EEcjs = require('../__chunks/FHIGX2EE.cjs');
require('../__chunks/NSONUP5C.cjs');


var _MWXEIKZXcjs = require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-input.tsx
var _misc = require('@ariakit/core/utils/misc');
var TagName = "input";
var useFormInput = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormInput2({ store, name: nameProp, ...props }) {
    const context = _FHIGX2EEcjs.useFormContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "FormInput must be wrapped in a Form component."
    );
    const name = String(nameProp);
    const onChangeProp = props.onChange;
    const onChange = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onChangeProp == null ? void 0 : onChangeProp(event);
      if (event.defaultPrevented) return;
      store == null ? void 0 : store.setValue(name, event.target.value);
    });
    const value = store.useValue(name);
    props = {
      value,
      ...props,
      onChange
    };
    props = _MWXEIKZXcjs.useFocusable.call(void 0, props);
    props = _B2PY6EORcjs.useFormControl.call(void 0, { store, name, ...props });
    return props;
  }
);
var FormInput = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function FormInput2(props) {
    const htmlProps = useFormInput(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.FormInput = FormInput; exports.useFormInput = useFormInput;
